

















































import Vue from "vue";
import axios, { AxiosResponse } from "axios";
import * as firebase from "firebase/app";
import Map from "@/components/Map.vue";
import { API_BASE_URL, COLOUR_OPTIONS } from "@/shared/global-values";
import { formatDate } from "@/shared/utils";
import IExpense from "@/types/expense";

export default Vue.extend({
  components: {
    Map,
  },
  data() {
    return {
      expense: { amount: 0 } as IExpense,
      isDisabled: false,
    };
  },
  async beforeMount(): Promise<void> {
    const id: string = this.$route.params.id;

    try {
      const token: string = await firebase.auth().currentUser!.getIdToken();
      const response: AxiosResponse = await axios.get(`${API_BASE_URL}/expenses/${id}`, { withCredentials: true, headers: { Authorization: `Bearer ${token}` } });
      this.expense = response.data.expense as IExpense;
      this.expense.date = formatDate(new Date(this.expense.date), "D MMM YY");

    } catch (error) {
      console.error(error);
    }
  },
  computed: {
    colourHex(): string {
      const colourOption: any = COLOUR_OPTIONS.find((option) => option.colour === this.expense.colour);
      if (colourOption) {
        return colourOption.hex;
      }
      return "#FFF0";
    },
  },
  methods: {
    async deleteExpense(): Promise<void> {
      this.isDisabled = true;

      const id: string = this.$route.params.id;

      try {
        const token: string = await firebase.auth().currentUser!.getIdToken();
        await axios.delete(`${API_BASE_URL}/expenses/${id}`, { withCredentials: true, headers: { Authorization: `Bearer ${token}` } });
        this.$router.push({ name: "Home" });

      } catch (error) {
        console.error(error);
      }
    },
  },
});
